import script from "./BannerOffers.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerOffers.vue?vue&type=script&setup=true&lang=js"

import "./BannerOffers.vue?vue&type=style&index=0&id=7abf3730&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7abf3730"]])

export default __exports__